import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  CreateJobUseCaseInput,
  CreateJobUseCaseOutput,
  IAppErrorFactory,
  ICreateJobUseCase,
  IErrorTrackingService,
  IJob,
  IJobFactory,
  IJobsService,
  IUseCaseOutputFactory,
} from '../../types'

@injectable()
export default class CreateJobInteractor implements ICreateJobUseCase {
  @inject(symbols.IJobsService) private jobsService: IJobsService

  @inject(symbols.IJobFactory) private jobFactory: IJobFactory

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IErrorTrackingService) private errorTrackingService: IErrorTrackingService

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    job: null | IJob
  }>

  async handle(input: CreateJobUseCaseInput): Promise<CreateJobUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        job: null,
      },
    })
    try {
      const base = await this.jobsService.createJob(input)
      output.data.job = this.jobFactory.create({ base })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }
}
